module.exports = __webpack_public_path__ + "img/sedan_stopped.e634435a.svg";